import { environment } from './../environments/environment';
import { EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@angular/router";
export class AuthService {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }
    get currentUserValue() {
        return this.currentUserSubject.value;
    }
    get user() {
        return JSON.parse(localStorage.getItem('currentUser'));
    }
    set user(user) {
        localStorage.setItem('currentUser', JSON.stringify(user));
    }
    get token() {
        return localStorage.getItem('escritha_token');
    }
    updateNavbarImg(imgURL) {
        const user = Object.assign({}, this.user, { url_image: imgURL });
        localStorage.setItem('currentUser', JSON.stringify(user));
        AuthService.profilePictureUpdated.emit(imgURL);
    }
    isAdvisor() {
        return this.getInvitationRole() === 'advisor';
    }
    isAuthorGuest() {
        return this.getInvitationRole() === 'author';
    }
    setInvitationRole(invitationRole) {
        try {
            localStorage.setItem('invitationRole', invitationRole);
        }
        catch (err) {
            console.error('Error saving to localStorage', err);
        }
    }
    getInvitationRole() {
        try {
            return localStorage.getItem('invitationRole');
        }
        catch (err) {
            console.error('Error getting data from localStorage', err);
            return null;
        }
    }
    setBlindSelection(value) {
        try {
            localStorage.setItem('blindSelection', value);
        }
        catch (err) {
            console.error('Error saving to localStorage', err);
        }
    }
    getBlindSelection() {
        try {
            return localStorage.getItem('blindSelection');
        }
        catch (err) {
            console.error('Error getting data from localStorage', err);
            return null;
        }
    }
    setParticipants(participants) {
        try {
            localStorage.setItem('participants', JSON.stringify(participants));
        }
        catch (err) {
            console.error('Error saving to localStorage', err);
        }
    }
    getParticipants() {
        try {
            return JSON.parse(localStorage.getItem('participants'));
        }
        catch (err) {
            console.error('Error getting data from localStorage', err);
            return [];
        }
    }
    canEvaluate() {
        const participants = this.getParticipants();
        if (participants && participants.length > 0) {
            const hasAdvisor = participants.find(p => p.role === 'advisor');
            if (hasAdvisor) {
                return ['advisor'].includes(this.getInvitationRole());
            }
        }
        return ['main_author'].includes(this.getInvitationRole());
    }
    canComment() {
        // const participants = this.getParticipants();
        // if (participants.length > 0) {
        //   const hasAdvisor = participants.find(p => p.role === 'advisor');
        //   if (hasAdvisor) {
        //     return ['advisor', 'co-supervisor', 'mentor'].includes(this.getInvitationRole());
        //   }
        // }
        return ['main_author', 'advisor', 'author', 'co-supervisor', 'mentor'].includes(this.getInvitationRole());
    }
    profile() {
        return this.http.get(`${environment.base_url}/auth/profile`);
    }
    removeInvitationRole() {
        localStorage.removeItem('invitationRole');
    }
    disconnect() {
        return this.http.get(`${environment.base_url}/auth/disconnect`);
    }
    logout() {
        localStorage.removeItem('currentUser');
        localStorage.removeItem('escritha_token');
        localStorage.removeItem('invitationRole');
        localStorage.removeItem('nameProject');
        localStorage.removeItem('template');
        this.currentUserSubject.next(null);
        this.router.navigate(['/']).then(() => window.location.href = environment.base_server);
    }
}
AuthService.profilePictureUpdated = new EventEmitter();
AuthService.profileUpdated = new EventEmitter();
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.Router)); }, token: AuthService, providedIn: "root" });
